import { configAxiosTransactions } from '@/utils/api-instance';
import { ENDPOINTS } from '@/utils/constants';

export const getCreditCards = async () => {
    const api = configAxiosTransactions();
    const { data } = await api.get(`${ENDPOINTS.SELECT_PAYMENT_CHECKOUT}`);
    return data;
};

export const createCreditCard = async (payload) => {
    const api = configAxiosTransactions();
    const { data } = await api.post(ENDPOINTS.SELECT_PAYMENT_CHECKOUT, payload);
    return data;
};

export const deleteCreditCard = async (id) => {
    const api = configAxiosTransactions();
    const { data } = await api.delete(`${ENDPOINTS.SELECT_PAYMENT_CHECKOUT}` + id);
    return data;
};

export const finishPayment = async (payload) => {
    const api = configAxiosTransactions();
    const { data } = await api.post(ENDPOINTS.FINISH_PAYMENT, payload);
    return data;
};

export const getPaymentStatus = async (id) => {
    const api = configAxiosTransactions();
    const { data } = await api.get(`${ENDPOINTS.GET_STATUS_PAYMENT}` + id);
    return data;
};